// Trail link showing how many rows flow through it. On hover: a palette to
// recolour it and a ✕ to remove it (the step or output is then left not
// connected).
import { useState } from "react";
import { BaseEdge, EdgeLabelRenderer, getSmoothStepPath } from "@xyflow/react";
import { ColorPicker } from "./colors";

const LinkEdge = ({ id, sourceX, sourceY, targetX, targetY, sourcePosition, targetPosition, markerEnd, data }) => {
  const [hover, setHover] = useState(false);
  const [path, labelX, labelY] = getSmoothStepPath({ sourceX, sourceY, targetX, targetY, sourcePosition, targetPosition, borderRadius: 12 });
  const { color } = data;

  return (
    <g onMouseEnter={() => setHover(true)} onMouseLeave={() => setHover(false)}>
      <path d={path} fill="none" stroke="transparent" strokeWidth={18} />
      <BaseEdge id={id} path={path} markerEnd={markerEnd} style={{ stroke: color, strokeWidth: 1.5 }} />
      <EdgeLabelRenderer>
        <div
          className="nodrag nopan pointer-events-auto absolute flex flex-col items-center gap-1"
          style={{ transform: `translate(-50%, -50%) translate(${labelX}px, ${labelY}px)` }}
          onMouseEnter={() => setHover(true)}
          onMouseLeave={() => setHover(false)}
        >
          {data.rows !== undefined && (
            <span className="rounded border bg-white px-1.5 py-px font-mono text-[11px] font-medium" style={{ borderColor: color, color }}>
              {data.rows.toLocaleString()} rows
            </span>
          )}
          <div className={`flex items-center gap-1 rounded-full bg-white shadow-sm transition ${hover ? "opacity-100" : "opacity-0"}`}>
            <ColorPicker
              title="Link colour"
              value={data.customColor}
              defaultColor={data.fromColor}
              defaultLabel="Match the card it comes from"
              onChange={data.onColor}
            />
            <button
              type="button"
              title="Remove link"
              onClick={data.onRemove}
              className="mr-1 flex h-4 w-4 items-center justify-center rounded-full border border-red-300 bg-white text-[10px] leading-none text-red-500"
            >
              ×
            </button>
          </div>
        </div>
      </EdgeLabelRenderer>
    </g>
  );
};

export default LinkEdge;
